(function () {
  const config = window.RCO_EMAIL_TRACKING_CONFIG || {}
  const RECENT_STORAGE_KEY = 'Concept:recently-viewed'

  function qs(selector, root = document) {
    return root.querySelector(selector)
  }

  function normalizeRecentIds() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(RECENT_STORAGE_KEY) || '[]')
      if (!Array.isArray(parsed)) return []
      return parsed.map((value) => `${value || ''}`.trim()).filter(Boolean)
    } catch (error) {
      return []
    }
  }

  function formatPrice(product) {
    if (!product || !product.price) return ''
    const amount = Number(product.price)
    if (!Number.isFinite(amount)) return `${product.price} ${product.currencyCode || ''}`.trim()
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: product.currencyCode || 'USD',
      }).format(amount)
    } catch (error) {
      return `${amount.toFixed(2)} ${product.currencyCode || ''}`.trim()
    }
  }

  function getFetchHeaders() {
    const headers = { 'Content-Type': 'application/json' }
    if (config.apiKey) {
      headers.apikey = config.apiKey
      headers.Authorization = `Bearer ${config.apiKey}`
    }
    return headers
  }

  async function addVariantToCart(slot, variantNumericId) {
    if (!variantNumericId || !window.theme || !window.theme.routes) return

    const formData = new FormData()
    formData.append('id', variantNumericId)
    formData.append('quantity', '1')
    formData.append('sections', slot.dataset.sectionId || '')
    formData.append('sections_url', window.location.pathname)

    const response = await fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
    })
    const parsedState = await response.json()

    if (parsedState.status) {
      throw new Error(parsedState.description || 'Unable to add product to cart.')
    }

    const cartJson = await (await fetch(`${window.theme.routes.cart_url}.js`, { method: 'GET', headers: { Accept: 'application/json' } })).json()
    cartJson.sections = parsedState.sections

    if (window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
      window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'rco-upsell',
        productVariantId: variantNumericId,
        cart: cartJson,
      })
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: parsedState,
        variantId: variantNumericId,
        source: 'rco-upsell',
      },
    }))
  }

  function buildProductCard(slot, product) {
    const article = document.createElement('article')
    article.className = 'rco-cart-upsell-card grid grid-cols-[72px_minmax(0,1fr)] gap-3 rounded-2xl border border-slate-200 bg-white p-3'

    const imageLink = document.createElement('a')
    imageLink.href = `/products/${product.handle}`
    imageLink.className = 'block overflow-hidden rounded-xl bg-slate-100'

    const image = document.createElement('img')
    image.src = product.image || ''
    image.alt = product.title || 'Upsell product'
    image.width = 72
    image.height = 72
    image.loading = 'lazy'
    image.className = 'h-[72px] w-[72px] object-cover'
    imageLink.appendChild(image)

    const body = document.createElement('div')
    body.className = 'min-w-0'

    const titleLink = document.createElement('a')
    titleLink.href = `/products/${product.handle}`
    titleLink.className = 'block text-sm font-medium leading-tight text-slate-900'
    titleLink.textContent = product.title || 'Product'

    const meta = document.createElement('div')
    meta.className = 'mt-1 flex items-center justify-between gap-2'

    const price = document.createElement('span')
    price.className = 'text-sm text-slate-500'
    price.textContent = formatPrice(product)

    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'button button--secondary whitespace-nowrap'
    button.textContent = product.availableForSale && product.variantNumericId ? 'Add' : 'View'
    button.addEventListener('click', async () => {
      if (!product.availableForSale || !product.variantNumericId) {
        window.location.href = `/products/${product.handle}`
        return
      }

      const original = button.textContent
      button.disabled = true
      button.textContent = 'Adding...'
      try {
        await addVariantToCart(slot, product.variantNumericId)
        button.textContent = 'Added'
      } catch (error) {
        console.error('[RCO Upsells]', error)
        button.textContent = 'View'
      } finally {
        window.setTimeout(() => {
          button.disabled = false
          button.textContent = original
        }, 1200)
      }
    })

    meta.append(price, button)
    body.append(titleLink, meta)
    article.append(imageLink, body)
    return article
  }

  function renderRecommendations(slot, payload) {
    const recommendations = Array.isArray(payload && payload.recommendations) ? payload.recommendations : []
    const activeGroup = recommendations.find((group) => Array.isArray(group.products) && group.products.length > 0)

    if (!activeGroup) {
      slot.hidden = true
      slot.innerHTML = ''
      return
    }

    const fragment = document.createDocumentFragment()

    const heading = document.createElement('div')
    heading.className = 'mb-3'

    const title = document.createElement('p')
    title.className = 'text-base font-semibold text-slate-900'
    title.textContent = activeGroup.rule && activeGroup.rule.title ? activeGroup.rule.title : 'You may also like'

    heading.appendChild(title)

    if (activeGroup.rule && activeGroup.rule.description) {
      const description = document.createElement('p')
      description.className = 'mt-1 text-sm text-slate-500'
      description.textContent = activeGroup.rule.description
      heading.appendChild(description)
    }

    const grid = document.createElement('div')
    grid.className = 'grid gap-3'

    activeGroup.products.forEach((product) => {
      grid.appendChild(buildProductCard(slot, product))
    })

    fragment.append(heading, grid)
    slot.innerHTML = ''
    slot.appendChild(fragment)
    slot.hidden = false
  }

  function getLiveCartProductIds(slot) {
    const drawer = slot.closest('cart-drawer') || document
    const items = Array.from(drawer.querySelectorAll('[data-handle]'))
    const ids = items.map((el) => `${el.dataset.handle || ''}`.trim()).filter(Boolean)
    if (ids.length > 0) return ids.join(',')
    return `${slot.dataset.cartProductIds || ''}`.trim()
  }

  async function hydrateSlot(slot) {
    if (!slot || !config.upsellEndpoint) return

    const cartProductIds = getLiveCartProductIds(slot)
    const recentProductIds = normalizeRecentIds().join(',')
    const params = new URLSearchParams({
      placement: slot.dataset.placement || 'cart_drawer',
      cartProductIds,
      recentProductIds,
      limit: '4',
    })

    const response = await fetch(`${config.upsellEndpoint}?${params.toString()}`, {
      method: 'GET',
      headers: getFetchHeaders(),
    })

    if (!response.ok) {
      throw new Error(`Upsell request failed with ${response.status}`)
    }

    const payload = await response.json()
    renderRecommendations(slot, payload)
  }

  function init() {
    const slots = Array.from(document.querySelectorAll('[data-rco-upsell-slot]'))
    if (slots.length === 0) return

    slots.forEach((slot) => {
      hydrateSlot(slot).catch((error) => {
        console.error('[RCO Upsells]', error)
      })
    })
  }

  document.addEventListener('DOMContentLoaded', init)
  document.addEventListener('cart:updated', init)
  document.addEventListener('cart:refresh', () => {
    window.setTimeout(init, 150)
  })
})()
